import { CircleArrowIcon } from '@components/ui/icon'

type Props = {
  cardRowNum: number
  size?: 'small' | 'medium'
}

export const ProgramCardMoreBtn = ({
  size,
  cardRowNum,
}: Props): JSX.Element => (
  <div
    className={`flex flex-row justify-center items-center bg-gradient-to-br from-primaryTo to-primaryFrom rounded-b-[20px] text-white ${
      cardRowNum === 3
        ? size === 'small'
          ? 'lg:h-[3vw] h-[6.7vw]'
          : 'lg:h-[3.9vw] h-[9vw]'
        : cardRowNum === 4
        ? size === 'small'
          ? 'h-[8.1vw] lg:h-[3.1vw]'
          : 'lg:h-[3.9vw] h-[8.1vw]'
        : ''
    }`}
  >
    <div className="flex relative justify-center items-center w-full h-full">
      <div
        className={`font-bold tracking-[0.3vw] lg:tracking-[0.1vw] ${
          size === 'small'
            ? 'lg:text-[1vw] text-[3.2vw]'
            : 'text-[3.2vw] lg:text-[1.4vw]'
        }`}
      >
        もっと見る
      </div>
      <div
        className={`absolute w-[3.5vw] lg:w-[1.1vw] ${
          cardRowNum === 4
            ? size === 'small'
              ? 'right-[4vw] lg:right-[1.7vw] bottom-[2.5vw] lg:bottom-[1.15vw]'
              : 'right-[4vw] lg:right-[2.5vw] bottom-[2.5vw] lg:bottom-[1.5vw]'
            : size === 'small'
            ? 'right-[4.3vw] lg:right-[3.2vw] bottom-[2vw] lg:bottom-[1vw]'
            : 'right-[4.3vw] lg:right-[3.2vw] bottom-[2vw] lg:bottom-[1.5vw]'
        }`}
      >
        <CircleArrowIcon />
      </div>
    </div>
  </div>
)
